import React from "react";
import { X, FileUp, Upload, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

export function ImportPreviewModal({
  showImportModal, setShowImportModal, importPreview, setImportPreview,
  isImporting, handleConfirmImport,
}) {
  if (!showImportModal || !importPreview) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={() => { setShowImportModal(false); setImportPreview(null); }}>
      <div className="bg-white rounded-xl shadow-2xl max-w-4xl w-full max-h-[85vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-5 py-4 border-b border-zinc-200">
          <div>
            <h3 className="font-semibold text-zinc-900 font-['Manrope'] flex items-center gap-2"><FileUp className="w-5 h-5 text-orange-500" />Aperçu de l'import</h3>
            <p className="text-xs text-zinc-500 mt-1">{importPreview.row_count} ligne(s) à importer • {importPreview.headers.length} colonne(s)</p>
          </div>
          <button onClick={() => { setShowImportModal(false); setImportPreview(null); }} className="p-2 hover:bg-zinc-100 rounded-lg transition-colors"><X className="w-5 h-5 text-zinc-500" /></button>
        </div>
        <div className="flex-1 overflow-auto p-4">
          <div className="border border-zinc-200 rounded-lg overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-orange-500 text-white">
                <tr>
                  <th className="px-3 py-2 text-left font-medium border-r border-orange-400">#</th>
                  {importPreview.headers.map((header, idx) => <th key={idx} className="px-3 py-2 text-left font-medium border-r border-orange-400 whitespace-nowrap">{header}</th>)}
                </tr>
              </thead>
              <tbody>
                {importPreview.rows.slice(0, 10).map((row, rowIdx) => (
                  <tr key={rowIdx} className={rowIdx % 2 === 0 ? "bg-white" : "bg-zinc-50"}>
                    <td className="px-3 py-2 border-r border-zinc-200 text-zinc-500 font-medium">{rowIdx + 1}</td>
                    {importPreview.headers.map((header, colIdx) => <td key={colIdx} className="px-3 py-2 border-r border-zinc-200 max-w-[200px] truncate">{row[header] || <span className="text-zinc-300 italic">vide</span>}</td>)}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {importPreview.row_count > 10 && <p className="text-xs text-zinc-500 mt-2 text-center">... et {importPreview.row_count - 10} ligne(s) supplémentaire(s)</p>}
        </div>
        <div className="flex items-center justify-between px-5 py-4 border-t border-zinc-200 bg-zinc-50 rounded-b-xl">
          <p className="text-sm text-zinc-600">Les lignes seront ajoutées au tableau existant.</p>
          <div className="flex items-center gap-3">
            <Button variant="outline" size="sm" onClick={() => { setShowImportModal(false); setImportPreview(null); }}>Annuler</Button>
            <Button size="sm" onClick={handleConfirmImport} disabled={isImporting} className="gap-2 bg-orange-500 hover:bg-orange-600">
              {isImporting ? <><RefreshCw className="w-4 h-4 animate-spin" />Import en cours...</> : <><Upload className="w-4 h-4" />Importer {importPreview.row_count} ligne(s)</>}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
